<template>
<main class="Page-styles-page Page-styles-desktop">
    <div class="bg" style="display: none">
      <div class="formm">
        <div class="card card-container">
          <div class="form-signin">
            <div class="row error" v-if="loginError">
              Kullanıcı adı yada şifre yanlış
            </div>
            <form v-on:submit.prevent="login">
              <p class="input_title pt">{{ t.user.username }}</p>
              <input type="text" class="login_box" v-model="username" name="username" required="">
              <p class="input_title">{{ t.user.password }}</p>
              <input type="password" class="login_box" v-model="password" name="password" required="">
              <button class="btn btn-lg btn-primary btn-signin" type="submit">Giriş</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="AccountWrapperContainer-styles-outer-container AccountWrapperContainer-styles-outer-container-tipico-desktop">
      <div class="Paper-styles-paper AccountWrapperContainer-styles-paper">
        <div class="AccountWrapperContainer-styles-column-left">
          <div class="AccountWrapperContainer-styles-image-container">
            <picture>
              <img src="/static/assets/img/left_column_banner_default.jpg" alt="account-banner" height="563" width="432"></picture>
            <div class="SimpleBannerContent-styles-banner">
              <div class="SimpleBannerContent-styles-text">{{ t.login_slogan }}</div>
            </div>
          </div>
        </div>
        <div class="AccountWrapperContainer-styles-column-right">
          <div class="Login-styles-login-wrapper Login-styles-desktop">
            <div class="LoginForm-styles-login">
              <div class="LoginFormHeader-styles-login-form-header-desktop LoginFormHeader-styles-login-form-header-desktop-tipico-desktop">
                <h2 class="LoginFormHeader-styles-title">{{ t.registration.form }}</h2></div>
              <div class="LoginForm-styles-desktop-register-cta">
                <div class="LoginForm-styles-account-informations LoginForm-styles-login-form-appendix LoginForm-styles-desktop">{{ t.dont_you_have_account }}&nbsp;<router-link :to="{name: 'Register'}" class="LoginForm-styles-login-form-appendix-link">{{ t.register_now }}</router-link></div>
              </div>
              <section class="LoginForm-styles-login-box">
                <symForm :options="opt" :data="formData" v-on:sended="getUserForm" :form="userForm" :formProcess="formProcess" v-if="userForm" />
              </section>
              <resetting />
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

    import symForm from '@/components/form/symForm.vue'
    import globalLoader from '@/components/ui/loader/globalLoader.vue'
    import Login from '@/components/auth/Login.vue'
    import Resetting from '@/components/user/form/resetting.vue'

    export default {
        name: 'register',
        components: { symForm, globalLoader, Login, Resetting },
        data () {
            return {
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                regions: [],
                breadcrumb: [],
                userOpened: false,
                userForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                },
                formData: []
            }
        },
        mounted () {
            this.getUserForm();
            this.fetchRegions();
        },
        notifications: {
            showFormError: { // You can have any name you want instead of 'showLoginError'
                title: 'Login Failed',
                message: 'Failed to authenticate',
                type: 'error' // You also can use 'VueNotifications.types.error' instead of 'error'
            }
        },
        methods: {
            async fetchRegions () {

                this.$http.get(api+'api/v1/regions')
                    .then(response => {

                        this.regions = response.body.result.regions;
                    }, response => {

                    })
            },
            async getUserForm (data) {


                    this.userForm = null;
                    this.formProcess = 0;
                    this.$bus.$emit('globalLoader', 1);
                    if(data) {
                        var ref = (this.$route.query.ref) ? this.$route.query.ref : '';
                        //this.userForm = null;
                        this.$http.post(api+'api/v1/user/registration/form?ref='+this.$route.query.ref,
                            data )
                            .then(response => {

                                this.userForm = response.body.result;
                                this.formProcess = 200;

                                swal('', this.t.registration.success, "success")
                                this.$bus.$emit('globalLoader', 0);

                                setTimeout(
                                    this.redirectHome()
                                , 3000);

                            }, response => {
                                this.userForm = response.body.result;
                                this.formProcess = 400;
                                //swal(this.t.processing.error, this.t.processing.check, "error")
                                this.$bus.$emit('globalLoader', 0);
                            })

                    } else {
                        this.$http.get(api+'api/v1/user/registration/form')
                            .then(response => {

                                this.userForm = response.body.result;
                                this.formData = response.body.form_data;
                                this.opt.region.data = this.regions;
                                this.opt.region.label = 'name'
                                this.$bus.$emit('globalLoader', 0);

		                        var language = window.navigator.userLanguage || window.navigator.language;

		                        setTimeout(() => {

		                            var v = this.getIpInfo().then(response => {
                                            var ip = response.body;

                                            document.getElementById("registration_region").text = ip.country;
                                            document.getElementById('registration_mobilePhone_country').value=ip.countryCode;

					                    }, response => {

				                        })

		                            document.getElementById('registration_timezone').value=Intl.DateTimeFormat().resolvedOptions().timeZone;
		                        }, 1000);

                        }, response => {
                                this.$bus.$emit('globalLoader', 0);
                        })
                    }

            },
	        redirectHome () {
                window.location.href = '/';
	        },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    .control-label {
        font-weight: bold;
    }
    .control-label.required::before{
        content: "* ";
    }
    .form-group {
        margin-bottom: 0.5rem;
    }
    .Register-title {
        font-size: 35px;
        text-align: center;
    }
    .help-block {
        text-align: right;
        color: red;
        font-weight: bold;
        font-size: 14px;
    }

    .register-form {
        padding-top: 30px;
        float: left;
        border-radius: 2px;
    background-color: var(--white);
    box-shadow: 0 0 2px 0 rgba(var(--black-box-shadow-rgb),.14),0 1px 3px 0 rgba(var(--black-box-shadow-rgb),.14);
    }

	.register-form .form-group {
		float: left !important;
		width: 20% !important;
		max-height: 65px;
		padding: 5px;
	}

	#registration_mobilePhone_number,#registration_mobilePhone_country {
		width: 100%;
	}

	#registration_dateOfBirth select{
		width: 33.1%;
	}

	.register-btn {
		margin: 0.5rem 0 50px;
		float: left;
		font-size: 30px;
		line-height: 45px;
        background-color: var(--blue);
        color: var(--white) !important;
	}

    .AccountWrapperContainer-styles-outer-container{padding-top:100px;padding-bottom:20px;width:900px;margin:0 auto}.AccountWrapperContainer-styles-outer-container .AccountWrapperContainer-styles-paper{display:flex}.AccountWrapperContainer-styles-outer-container-games .AccountWrapperContainer-styles-image-container:not(.AccountWrapperContainer-styles-no-gradient):after,.AccountWrapperContainer-styles-outer-container-mysino-account .AccountWrapperContainer-styles-image-container:not(.AccountWrapperContainer-styles-no-gradient):after,.AccountWrapperContainer-styles-outer-container-mysino-games .AccountWrapperContainer-styles-image-container:not(.AccountWrapperContainer-styles-no-gradient):after,.AccountWrapperContainer-styles-outer-container-mysino-payment .AccountWrapperContainer-styles-image-container:not(.AccountWrapperContainer-styles-no-gradient):after{background-image:-o-linear-gradient(bottom,var(--firefly),transparent);background-image:linear-gradient(0deg,var(--firefly),transparent)}.AccountWrapperContainer-styles-outer-container-games .AccountWrapperContainer-styles-column-left,.AccountWrapperContainer-styles-outer-container-mysino-account .AccountWrapperContainer-styles-column-left,.AccountWrapperContainer-styles-outer-container-mysino-games .AccountWrapperContainer-styles-column-left,.AccountWrapperContainer-styles-outer-container-mysino-payment .AccountWrapperContainer-styles-column-left{background:var(--firefly)}.AccountWrapperContainer-styles-column-left{flex:0 0 432px;background:var(--black-box-shadow);min-height:750px}.AccountWrapperContainer-styles-column-left img{width:100%}.AccountWrapperContainer-styles-column-right{flex:1;padding:34px 48px}.AccountWrapperContainer-styles-column-right h1{font-size:26px;padding:0 24px;margin-top:14px;margin-bottom:6px}.AccountWrapperContainer-styles-image-container{width:100%;position:relative}.AccountWrapperContainer-styles-image-container:not(.AccountWrapperContainer-styles-no-gradient):after{content:" ";position:absolute;width:100%;height:30%;bottom:0;left:0;background-image:-o-linear-gradient(bottom,var(--black-box-shadow),transparent);background-image:linear-gradient(0deg,var(--black-box-shadow),transparent)}.SimpleBannerContent-styles-banner{margin:-150px 32px 0}.SimpleBannerContent-styles-banner .SimpleBannerContent-styles-text{font-size:40px;line-height:48px;color:var(--white);padding:0 48px;transform:translateY(50%);font-weight:600;font-style:normal;position:absolute;width:100%;bottom:0;left:0;z-index:2}.Login-styles-login-wrapper{display:flex;flex-direction:column;justify-content:space-between;width:100%;height:100vh;padding:8px 16px;margin:auto}@media only screen and (min-width:768px){.Login-styles-login-wrapper{max-width:768px}}.Login-styles-login-wrapper.Login-styles-desktop{height:inherit;padding-top:38px}.Login-styles-login-wrapper.Login-styles-desktop h2{font-size:26px}.Login-styles-login-header{display:flex;position:relative;margin-top:env(safe-area-inset-top,24px)}.Login-styles-login-header>div{flex:1}.Login-styles-login-header>div:first-child{text-align:left;align-content:start}.Login-styles-login-header>div:nth-child(2){text-align:right;align-content:end}.Login-styles-login-header-image>img{position:relative;top:4px;left:4px}.Login-styles-login-header-image-bundesliga6>img{display:none}.Login-styles-close-button{display:block;width:20px;height:20px;position:absolute;top:8px;right:8px;overflow:hidden;cursor:pointer}.Login-styles-close-button:hover:after,.Login-styles-close-button:hover:before{background:var(--blue)}.Login-styles-close-button:after,.Login-styles-close-button:before{content:"";position:absolute;height:2px;width:100%;top:50%;left:0;margin-top:-1px;background:var(--grey)}.Login-styles-close-button:before{-webkit-transform:rotate(45deg);transform:rotate(45deg)}.Login-styles-close-button:after{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.Login-styles-close-button.Login-styles-close-button-bundesliga6.Login-styles-native-ios{margin-top:24px}@media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:3),only screen and (device-width:414px) and (device-height:896px) and (-webkit-device-pixel-ratio:2),only screen and (device-width:414px) and (device-height:896px) and (-webkit-device-pixel-ratio:3){.Login-styles-close-button.Login-styles-close-button-bundesliga6.Login-styles-native-ios{margin-top:44px}}.Login-styles-close-button.Login-styles-close-button-bundesliga6.Login-styles-native-android{margin-top:24px}.LoginForm-styles-login{display:flex;flex-direction:column;flex:1 0 auto;width:100%;justify-content:center}.LoginForm-styles-login .LoginForm-styles-login-box>form{display:flex;flex:1;flex-direction:column}.LoginForm-styles-login .LoginForm-styles-biometric-login{display:flex;flex-direction:column}.LoginForm-styles-login .LoginForm-styles-biometric-login .LoginForm-styles-mobile-buttons{margin:16px 0}.LoginForm-styles-login .LoginForm-styles-account-informations{padding-top:15px;display:block;text-align:center;font-size:15px}.LoginForm-styles-login .LoginForm-styles-account-informations a{color:var(--blue-steel);text-decoration:none}.LoginForm-styles-login .LoginForm-styles-customer-card{margin-top:64px}.LoginForm-styles-login .LoginForm-styles-login-form-appendix{padding-bottom:24px}.LoginForm-styles-login .LoginForm-styles-login-form-appendix-link{font-weight:600}.LoginForm-styles-message-margin{margin:0}.LoginForm-styles-message-transparent,.LoginForm-styles-messages-transparent div{background:none;color:var(--red);align-items:center;padding:0}.LoginForm-styles-message-transparent{padding-bottom:8px}.LoginForm-styles-recaptcha{display:flex;justify-content:center;margin-top:24px}.LoginForm-styles-submit-button{margin:24px 0}.LoginForm-styles-warning-message{color:var(--black)}.LoginForm-styles-hidden-input{display:none}.LoginForm-styles-desktop-register-cta .LoginForm-styles-login-form-appendix.LoginForm-styles-desktop{text-align:left}.LoginForm-styles-desktop-register-cta .LoginForm-styles-login-form-appendix-link{font-weight:inherit}.LoginForm-styles-sh-link-here{color:var(--blue-steel);font-weight:600;text-decoration:underline;cursor:pointer}.MobileButton-styles-mobile-button{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;height:64px;border-radius:4px;border:1px solid var(--blue);background-color:var(--white);padding-left:44px;margin-bottom:16px}.MobileButton-styles-mobile-button .MobileButton-styles-icon{position:absolute;width:32px;height:32px;top:16px;left:12px}.MobileButton-styles-mobile-button .MobileButton-styles-primary-text{font-size:17px;color:var(--blue);font-weight:600;margin-bottom:4px}.MobileButton-styles-mobile-button .MobileButton-styles-secondary-text{font-size:13px;color:var(--grey-light)}.app-container,body,html{min-height:100%}.LoginFormHeader-styles-login-form-header-desktop .LoginFormHeader-styles-title{margin:0;font-size:22px;font-weight:600;color:var(--black);line-height:1.18}.LoginFormHeader-styles-login-form-header{display:flex;flex-direction:column;align-items:center}.LoginFormHeader-styles-login-form-header.LoginFormHeader-styles-desktop{margin-bottom:32px}.LoginFormHeader-styles-login-form-header .LoginFormHeader-styles-title{margin:0;font-size:22px;font-weight:600;color:var(--black);line-height:1.18}.LoginFormHeader-styles-login-form-header .LoginFormHeader-styles-logo{height:32px}.LoginFormHeader-styles-login-form-header .LoginFormHeader-styles-text{font-size:15px;line-height:1.4;font-weight:400;color:var(--grey-dark);text-align:center;padding-top:8px}


</style>



// WEBPACK FOOTER //
// src/components/user/registration.vue